import Slider from "../common/classes/slider.es6";

export default class ImgSlider {
    constructor() {
        this.init();
    }

    init() {
        this.setImgSlider();
    }

    setImgSlider() {
        const jktContent = document.querySelector(".js-jacket-slider");
        const tokutenContent = document.querySelector(".js-tokuten-slider");
        const tokutenModalContents = document.querySelectorAll(".js-tokuten-modal-slider");
        const tokutenShopSliders = document.querySelectorAll(".js-tokuten-shop-slider");

        if (jktContent) {
            const swiperJkt = new Slider(jktContent, {
                autoplay: { delay: 5000, disableOnInteraction: false },
                loop: true,
                pagination: {
                    el: ".js-jacket-slider-pagination",
                    clickable: true,
                },
            });
        }

        if (tokutenContent) {
            const swiperTokuten = new Slider(tokutenContent, {
                autoplay: { delay: 5000 },
                loop: true,
                pagination: {
                    el: ".js-tokuten-slider-pagination",
                    clickable: true,
                },
            });
        }

        if (tokutenModalContents.length) {
            tokutenModalContents.forEach((tokutenModalContent) => {
                const wrapper = tokutenModalContent.closest(".bddvd__tokuten__modal__contwrap");
                if (!wrapper) return;
                const pagination = wrapper.querySelector(".js-tokuten-modal-slider-pagination");
                const prev = wrapper.querySelector(".js-tokuten-modal-slider-prev");
                const next = wrapper.querySelector(".js-tokuten-modal-slider-next");

                const swiperTokutenModal = new Slider(tokutenModalContent, {
                    loop: true,
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                    navigation: {
                        prevEl: prev,
                        nextEl: next,
                    }
                });
            });
        }

        if (tokutenShopSliders.length) {
            tokutenShopSliders.forEach((tokutenShopSlider) => {
                const wrapper = tokutenShopSlider.closest(".bddvd__tokuten__shop__list__item__thumb");
                if (!wrapper) return;
                const pagination = wrapper.querySelector(".js-tokuten-shop-slider-pagination");

                // ドットクリックがサムネイルのモーダルオープンに伝播しないようにする
                if (pagination) {
                    pagination.addEventListener("click", (e) => e.stopPropagation());
                }

                const swiperTokutenShop = new Slider(tokutenShopSlider, {
                    autoplay: { delay: 5000, disableOnInteraction: false },
                    loop: true,
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                });
            });
        }
    }
}
